import {
    isEmpty as _isEmpty,
    sumBy as _sumBy,
    min as _min
} from '@lodash';
import StoreUtil from '@store/StoreUtil';
import IBetSlipState from '../types';
import LottoSystem from '@core/models/lottoBetSlip/LottoSystem';
import Combinations from '@core/utils/math/Combinations';

export default {
    systems(state: IBetSlipState, getters: any): LottoSystem[] {
        const systems: LottoSystem[] = [];
        if (getters.isEmpty) {
            return systems;
        }
        const systemCount = _min([getters.selectionsCount, getters.maxBettableNumber])!;
        for (let i = 1; i <= systemCount; i += 1) {
            systems.push(createSystem(
                i,
                getters.selectionsCount,
                !!getters.selectedSystemsMap[i])
            );
        }
        return systems;
    },

    selectedSystems: (state: IBetSlipState, getters: any): LottoSystem[] =>
        getters.systems.filter((s: LottoSystem) => s.isSelected),

    payoutSystems: (state: IBetSlipState, getters: any): number[] =>
        getters.selectedSystems.map((system: LottoSystem) => system.id),

    isAtLeastOneSystemSelected(state: IBetSlipState, getters: any): boolean {
        return !_isEmpty(getters.selectedSystems);
    },

    /**
     * For simple ticket number is 1
     * For system ticket number is sum of selected system's combinations
     */
    totalNumberOfSelectedCombinations(state: IBetSlipState, getters: any): number {
        if (getters.isEmpty) {
            return 0;
        }
        if (getters.isSimple) {
            return 1;
        }
        return getters.selectedCombinationsCount;
    },

    selectedCombinationsCount(state: IBetSlipState, getters: any): number {
        return _sumBy(getters.selectedSystems, 'combinationCount');
    },

    selectedSystemsMap: StoreUtil.createSimpleGetter('selectedSystems'),
    undoSelectedSystems: StoreUtil.createSimpleGetter('undoSelectedSystems'),
};

const createSystem = (order: number, selectionsCount: number, isSelected: boolean): LottoSystem => {
    const system = new LottoSystem(
        order,
        isSelected
    );
    system.name = createSystemName(order, selectionsCount);
    system.combinationCount = calculateCombinationCount(order, selectionsCount);
    return system;
};

const createSystemName = (selectionOrder: number, selectionsCount: number) =>
    `${selectionOrder}/${selectionsCount}`;

const calculateCombinationCount = (selectionOrder: number, selectionsCount: number) =>
    new Combinations(selectionsCount, selectionOrder).getNumberOfCombinations();



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/ui/lotto/betSlip/getters/systems.ts